export default __webpack_public_path__ + "static/media/man1.3aaab72c.jpg";